import queryString from 'query-string';

export const urlWithQuery = <S extends object>(url: string, query: S): string => {
  const stringifiedQuery = queryString.stringify(query, { arrayFormat: 'bracket' });

  return stringifiedQuery ? `${url}?${stringifiedQuery}` : url;
};
